import { normalizeAppLanguage } from "util/locale";

export function emptyLocaleContent() {
  return {
    widgetHeaderTitle: "",
    name: "",
    description: "",
    questions: {},
  };
}

export function snapshotFormToLocale(form) {
  const questions = {};
  (form.questions || []).forEach((q) => {
    if (!q?.id) return;
    questions[q.id] = {
      text: q.text || "",
      options: [...(q.options || [])],
    };
  });
  return {
    widgetHeaderTitle: form.widgetHeaderTitle || "",
    name: form.name || "",
    description: form.description || "",
    questions,
  };
}

export function applyLocaleToForm(form, locale) {
  const loc = locale || emptyLocaleContent();
  const questions = (form.questions || []).map((q) => {
    const translated = loc.questions?.[q.id];
    if (!translated) {
      return { ...q, text: "", options: (q.options || []).map(() => "") };
    }
    const options = [...(q.options || [])];
    const translatedOptions = [...(translated.options || [])];
    return {
      ...q,
      text: translated.text || "",
      options: options.map((_, index) => translatedOptions[index] || ""),
    };
  });

  return {
    ...form,
    widgetHeaderTitle: loc.widgetHeaderTitle || "",
    name: loc.name || "",
    description: loc.description || "",
    questions,
  };
}

export function buildTranslationsPayload(form) {
  const primaryLanguage = normalizeAppLanguage(form.primaryLanguage);
  const translations = { ...(form.translations || {}) };
  translations[form.editingLanguage] = snapshotFormToLocale(form);

  const primaryLocale =
    translations[primaryLanguage] || snapshotFormToLocale(form);

  return {
    primaryLanguage,
    translations,
    primaryLocale,
  };
}

export function translationsFromConfig(cfg = {}) {
  const primaryLanguage = normalizeAppLanguage(cfg.primary_language || "en");
  const raw = cfg.translations || {};
  const translations = {};

  Object.keys(raw).forEach((lang) => {
    const code = normalizeAppLanguage(lang);
    const entry = raw[lang] || {};
    const questions = {};
    const qMap = entry.questions || {};
    if (Array.isArray(qMap)) {
      qMap.forEach((q) => {
        if (q?.id) {
          questions[q.id] = {
            text: q.text || "",
            options: [...(q.options || [])],
          };
        }
      });
    } else {
      Object.keys(qMap).forEach((qid) => {
        const q = qMap[qid] || {};
        questions[qid] = {
          text: q.text || "",
          options: [...(q.options || [])],
        };
      });
    }
    translations[code] = {
      widgetHeaderTitle: entry.widget_header_title || "",
      name: entry.title || entry.name || "",
      description: entry.description || "",
      questions,
    };
  });

  if (!translations[primaryLanguage]) {
    translations[primaryLanguage] = {
      widgetHeaderTitle: cfg.widget_header_title || "",
      name: "",
      description: "",
      questions: {},
    };
  }

  return { primaryLanguage, translations };
}

export function translationsToConfigPayload(primaryLanguage, translations) {
  const out = {};
  Object.keys(translations || {}).forEach((lang) => {
    const code = normalizeAppLanguage(lang);
    const entry = translations[lang] || emptyLocaleContent();
    const questions = {};
    Object.keys(entry.questions || {}).forEach((qid) => {
      const q = entry.questions[qid] || {};
      questions[qid] = {
        text: (q.text || "").trim(),
        options: (q.options || []).map((o) => (o || "").trim()),
      };
    });
    out[code] = {
      title: (entry.name || "").trim(),
      description: (entry.description || "").trim(),
      widget_header_title: (entry.widgetHeaderTitle || "").trim(),
      questions,
    };
  });
  return {
    primary_language: normalizeAppLanguage(primaryLanguage),
    translations: out,
  };
}
